import { ValuePropsArg } from '@components/ValuePropsSection';

export const HERO_VIDEO_URL = 'https://player.vimeo.com/video/531025176?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479';

export const WEDDING_REGISTRY_VALUE_PROPS: ValuePropsArg[] = [
  {
    id: 'weddingValuePropsFreeShipping',
    url: 'https://withjoy.com/shipping-policy',
    icon: 'freeShipping',
    title: 'Free <br />Shipping',
  },
  {
    id: 'weddingValuePropsCompletionDiscount',
    url: 'https://help.withjoy.com/knowledge-base/20-percent-post-wedding-discount',
    icon: 'tag',
    title: '20% Completion <br />Discount',
  },
  {
    id: 'weddingValuePropsZeroFeeCashFunds',
    url: 'https://help.withjoy.com/knowledge-base/are-there-any-fees-when-using-joy-cash-funds',
    icon: 'noFees',
    title: 'Zero-Fee <br />Cash Funds',
  },
  {
    id: 'weddingValuePropsEasyReturns',
    url: 'https://withjoy.com/return-policy',
    icon: 'syncItem',
    title: 'Easy <br />Returns',
  },
];
